import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth } from 'firebase/auth';
import { getFirestore, collection, query, where, onSnapshot } from 'firebase/firestore';

const PrintPreview = () => {
  const navigate = useNavigate();
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [subscriptionChecked, setSubscriptionChecked] = useState(false);
  const auth = getAuth();
  const db = getFirestore();

  // Firestore subscription check (as before)
  const checkSubscriptionStatus = (userId) => {
    if (!userId) return;
    const subscriptionRef = collection(db, "users", userId, "subscriptions");
    const q = query(subscriptionRef, where("status", "in", ["trialing", "active"]));
    return onSnapshot(q, (snapshot) => {
      setIsSubscribed(snapshot.docs.length > 0);
      setSubscriptionChecked(true);
    });
  };

  useEffect(() => {
    const unsubscribeAuth = auth.onAuthStateChanged((user) => {
      if (user) {
        const unsubscribeSubs = checkSubscriptionStatus(user.uid);
        return () => unsubscribeSubs && unsubscribeSubs();
      } else {
        setSubscriptionChecked(true);
      }
    });
    return () => unsubscribeAuth();
  }, [auth, db]);

  // Retrieve the paid token (if any) from localStorage.
  const paidTokenObj = localStorage.getItem("paidToken");
  const resumeHtml = localStorage.getItem("resumeHtml");

  useEffect(() => {
    if (subscriptionChecked) {
      // Check if token exists and hasn't expired.
      let tokenValid = false;
      if (paidTokenObj) {
        try {
          const { token, expires } = JSON.parse(paidTokenObj);
          if (Date.now() < expires) {
            tokenValid = true;
          } else {
            localStorage.removeItem("paidToken");
          }
        } catch (e) {
          console.error("Error parsing paidToken", e);
          localStorage.removeItem("paidToken");
        }
      }

      // Guard: allow access if either token is valid or if user is subscribed.
      if (!(tokenValid || isSubscribed)) {
        alert("Access denied. Please complete your payment or subscribe first.");
        navigate('/');
      } else if (resumeHtml) {
        // Delay briefly then trigger print dialog.
        setTimeout(() => {
          window.print();
        }, 500);
      }
    }
  }, [paidTokenObj, isSubscribed, subscriptionChecked, resumeHtml, navigate]);


  return (
    <div>
      <style>
        {`
          @media print {
            nav, footer {
              display: none !important;
            }
            * {
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
            }
            body, p {
              color: #000 !important;
            }
            /* Avoid breaking inside certain elements */
            section, h2, h3, .entry, .sidebar, p {
              page-break-inside: avoid;
              break-inside: avoid;
            }
            h3 {
              -webkit-column-break-inside: avoid !important;
              page-break-inside: avoid !important;
              break-inside: avoid !important;
            }
            @page {
              size: A4;
              margin: 0;
            }
          }

        `}
      </style>
      <div id="resume-container" dangerouslySetInnerHTML={{ __html: resumeHtml }} />
    </div>
  );
  
};

export default PrintPreview;
